const WEB_MODE = {
  development: "development",
  production: "production",
};

const FEATURE_PUBLIC = {
  true: "true",
  false: "false",
};

const featureDisplay = (featurePublic = "") => {
  if (!featurePublic) return false;
  // 可以依據 WEB_MODE 各自設定邏輯
  return featurePublic.toString() === FEATURE_PUBLIC.true;
};

export default featureDisplay;
